import React from 'react';
import PropTypes from 'prop-types';
import calculatePrice from '../../helpers/calculatePrice';
import Currency from 'react-currency-formatter';
import fixCornerWardrobeDepth from 'helpers/fixCornerWardrobeDepth';

const isLeft = safo => {
  const name = safo.split('/')[0];
  const side = name.toLowerCase()[name.length - 1];
  return side === 'l';
};

const SummaryListItem = props => {
  const { product, setProduct, index, setHighlightedWardrobe } = props;
  const cornerIndexes = [9, 10, 11];

  let isCorner = false;

  cornerIndexes.forEach(index => {
    if (product.types.hasOwnProperty(index)) {
      isCorner = true;
    }
  });

  const price = calculatePrice(product);

  const showSummaryPopup = product => {
    setProduct(product);
  };

  return (
    <li
      className="summary-list__item"
      onClick={() => showSummaryPopup(product)}
      onMouseEnter={() => setHighlightedWardrobe(index)}
      onMouseLeave={() => setHighlightedWardrobe(null)}>
      <img
        className="summary-list__img"
        title="Podsumowanie szafy"
        src={
          isCorner
            ? `${process.env.PUBLIC_URL}/img/wardrobe-shapes/corner-wardrobe-shape.png`
            : `${process.env.PUBLIC_URL}/img/wardrobe-shapes/wardrobe-shape.png`
        }
        alt=""
      />
      <div className="summary-list__info">
        <p className="summary-list__title">
          {product.is_corner === false ? 'Szafa ' : 'Szafa narożna '}
        </p>
        <p className="summary-list__paragraph">
          Cena:&nbsp;
          {price && (
            <>
              <span className="summary-list__bold-price">
                <Currency quantity={price.overall.actual} currency="PLN" />
              </span>
              &nbsp;
              {price.overall.actual < price.overall.regular && (
                <del>
                  <Currency quantity={price.overall.regular} currency="PLN" />
                </del>
              )}
            </>
          )}
        </p>
        {product.is_corner && !isLeft(product.safo) ? (
          <p className="summary-list__paragraph summary-list__small-text">
            Wymiary: gł.{' '}
            {fixCornerWardrobeDepth(product, 'Narożnik 66x45', product.dimensions.x, 70)} cm, szer.{' '}
            {product.dimensions.z} cm, wys. {product.dimensions.y} cm.
          </p>
        ) : (
          <p className="summary-list__paragraph summary-list__small-text">
            Wymiary: gł.{' '}
            {fixCornerWardrobeDepth(product, 'Narożnik 45x66', product.dimensions.z, 70)} cm, szer.{' '}
            {product.dimensions.x} cm, wys. {product.dimensions.y} cm.
          </p>
        )}
        <div>
          <p className="summary-list__paragraph summary-list__small-text summary-list__more-info">
            zobacz szczegóły
          </p>
        </div>
      </div>
    </li>
  );
};

SummaryListItem.propTypes = {
  product: PropTypes.object.isRequired,
  setProduct: PropTypes.func.isRequired,
};

export default SummaryListItem;
